<template>
  <div v-show="simulation.offerParams.isCreditInsuranceAccelerated" class="subcard is-gray">
    <div class="subcard-header">
      <p class="header-title">Dividendo</p>
      <b-button
        class="header-icon"
        size="is-small"
        :icon-left="localShow ? 'angle-up' : 'angle-down'"
        @click="toggle" />
    </div>

    <div v-show="localShow" class="subcard-content fields-has-text-right">
      <b-field class="has-addons" custom-class="columns">
        <div class="column is-4 is-flex is-align-items-center is-flex-direction-column">
          <small class="text-center has-text-grey-light pr-1">&nbsp;</small>
          <div class="field has-addons">
            <p class="control">
              <a class="button is-static">UF</a>
            </p>
            <b-input
              :disabled="readOnly"
              size="is-small"
              :type="determineInputType(firstPaymentGracePeriod())"
              placeholder="Ingresa el valor"
              :value="firstPaymentGracePeriod()"
              expanded />
          </div>
        </div>
        <div class="column is-4 is-flex is-align-items-center is-flex-direction-column">
          <small class="text-center has-text-grey-light pr-1">desde</small>
          <div class="field has-addons ">
            <p class="control">
              <a class="button is-static">Cuota</a>
            </p>
            <b-input
              :disabled="readOnly"
              size="is-small"
              :type="determineInputType(startMonthOfGracePeriod())"
              placeholder="Ingresa el valor"
              :value="startMonthOfGracePeriod()"
              expanded />
          </div>
        </div>
        <div class="column is-4 is-flex is-align-items-center is-flex-direction-column">
          <small class="text-center has-text-grey-light pr-1">hasta</small>
          <div class="field has-addons ">
            <p class="control">
              <a class="button is-static">Cuota</a>
            </p>
            <b-input
              :disabled="readOnly"
              size="is-small"
              :type="determineInputType(endMonthOfGracePeriod())"
              placeholder="Ingresa el valor"
              :value="endMonthOfGracePeriod()"
              expanded />
          </div>
        </div>
      </b-field>
      <b-field class="has-addons" custom-class="columns">
        <div class="column is-4 is-flex is-align-items-center is-flex-direction-column">
          <small class="text-center has-text-grey-light pr-1">&nbsp;</small>
          <div class="field has-addons">
            <p class="control">
              <a class="button is-static">UF</a>
            </p>
            <b-input
              :value="firstPayment()"
              :disabled="readOnly"
              size="is-small"
              :type="determineInputType(firstPayment())"
              placeholder="Ingresa el valor"
              expanded />
          </div>
        </div>

        <div class="column is-4 is-flex is-align-items-center is-flex-direction-column">
          <small class="text-center has-text-grey-light pr-1">desde</small>
          <div class="field has-addons ">
            <p class="control">
              <a class="button is-static">Cuota</a>
            </p>
            <b-input
              :value="firstPaymentInstallmentNumber()"
              :disabled="readOnly"
              size="is-small"
              :type="determineInputType(firstPaymentInstallmentNumber())"
              placeholder="Ingresa el valor"
              expanded />
          </div>
        </div>
        <div class="column is-4 is-flex is-align-items-center is-flex-direction-column">
          <small class="text-center has-text-grey-light pr-1">hasta</small>
          <div class="field has-addons ">
            <p class="control">
              <a class="button is-static">Cuota</a>
            </p>
            <b-input
              :value="secondLastPaymentInstallmentNumber()"
              :disabled="readOnly"
              size="is-small"
              :type="determineInputType(secondLastPaymentInstallmentNumber())"
              placeholder="Ingresa el valor"
              expanded />
          </div>
        </div>
      </b-field>
      <b-field class="has-addons" custom-class="columns">
        <div class="field has-addons column is-4">
          <p class="control">
            <a class="button is-static">UF</a>
          </p>
          <b-input
            :value="lastPayment()"
            :disabled="readOnly"
            size="is-small"
            :type="determineInputType(lastPayment())"
            placeholder="Ingresa el valor"
            expanded />
        </div>
        <div class="column is-4">
          <div class="field has-addons ">
            <p class="control">
              <a class="button is-static">Cuota</a>
            </p>
            <b-input
              :disabled="readOnly"
              :value="lastPaymentInstallmentNumber()"
              size="is-small"
              :type="determineInputType(lastPaymentInstallmentNumber())"
              placeholder="Ingresa el valor"
              expanded />
          </div>
        </div>
      </b-field>
    </div>
  </div>
</template>

<script>
import { getSafe } from '@/application/services/get-safe';

export default {
  name: 'DividendSubCard',
  props: {
    showContent: {
      type: Boolean,
      default: true,
      required: true
    },
    simulation: {
      type: Object,
      required: true
    },
    readOnly: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    localShow: null
  }),
  computed: {
    amortizationSchedule() {
      return getSafe(this, 'simulation.amortizationSchedule', {});
    },
    amortizationScheduleRows() {
      return this.simulation?.amortizationScheduleRows || [];
    }
  },
  created() {
    this.localShow = this.showContent;
  },
  methods: {
    determineInputType(value) {
      return !Number.isNaN(parseFloat(value)) && Number.isFinite(value) ? 'number' : 'text';
    },
    toggle() {
      this.localShow = !this.localShow;
    },
    startMonthOfGracePeriod() {
      return 1;
    },
    getSimulationValue(path, defaultValue) {
      try {
        const value = path.split('.').reduce((o, i) => o[i], this.simulation);
        return value || defaultValue;
      } catch (_e) {
        return defaultValue;
      }
    },
    endMonthOfGracePeriod() {
      return this.getSimulationValue('amortizationSchedule.numberOfGraceMonths', '---');
    },
    firstPaymentInstallmentNumber() {
      return this.getSimulationValue('amortizationSchedule.firstPayment.paymentNumber', '---');
    },
    secondLastPaymentInstallmentNumber() {
      const numberOfMonths = this.getSimulationValue('amortizationSchedule.numberOfMonths', null);
      return numberOfMonths ? numberOfMonths - 1 : '---';
    },
    lastPaymentInstallmentNumber() {
      return this.getSimulationValue('amortizationSchedule.numberOfMonths', '---');
    },
    firstPaymentGracePeriod() {
      try {
        return this.amortizationScheduleRows[
          0
        ].monthlyPayment;
      } catch (_e) {
        return '---';
      }
    },
    firstPayment() {
      try {
        return this.amortizationScheduleRows[
          this.amortizationSchedule.numberOfGraceMonths
        ].monthlyPayment;
      } catch (_e) {
        return '---';
      }
    },
    lastPayment() {
      try {
        return this.amortizationScheduleRows[
          this.amortizationSchedule.numberOfMonths - 1
        ].monthlyPayment;
      } catch (_e) {
        return '---';
      }
    }
  }
};
</script>

<style scoped>
</style>
